"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observableRetryStrategy = exports.ObservableRetryStrategy = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var retry_service_1 = require("./retry-service");
var ObservableRetryStrategy = /** @class */ (function () {
    function ObservableRetryStrategy() {
        this.strategy = function (options, internal) { return function (errorObs) {
            return errorObs.pipe((0, operators_1.flatMap)(function (error, i) {
                var canRetryError = options.canRetryError(error);
                if (!canRetryError) {
                    // request cannot be retried
                    return (0, rxjs_1.throwError)(error);
                }
                var retryAttempt = i + 1;
                var maximumRetryAttemptsMet = retryAttempt > options.maxAttempts;
                if (maximumRetryAttemptsMet) {
                    // request cannot be retried anymore due to maximum attempts
                    return (0, rxjs_1.throwError)(error);
                }
                var retryInTimeResult = retry_service_1.retryService.canRetryInTime(internal.startTime, options.maxCumulativeWaitTimeMs);
                if (!retryInTimeResult.canRetry) {
                    // request should not be retried anymore as allowed time expired
                    return (0, rxjs_1.throwError)(error);
                }
                // get wait time
                var retryAfter = retry_service_1.retryService.tryGetRetryAfterInMsFromError(error);
                var waitTime = retry_service_1.retryService.getNextWaitTimeMs(options.addJitter, options.deltaBackoffMs, retryAttempt, retryAfter);
                // debug log attempt
                retry_service_1.retryService.debugLogAttempt(retryAttempt, waitTime);
                return (0, rxjs_1.timer)(waitTime);
            }));
        }; };
    }
    return ObservableRetryStrategy;
}());
exports.ObservableRetryStrategy = ObservableRetryStrategy;
exports.observableRetryStrategy = new ObservableRetryStrategy();
//# sourceMappingURL=observable-retry-strategy.js.map